import { Form } from "@repo/ui";
import { useForm } from "react-hook-form";
import FormInput from "ui/Input";

export default function CustomerDetails({ customer }) {
  const form = useForm({ defaultValues: { ...customer } });
  const generalProps = { errors: form.formState.errors, control: form.control };
  return (
    <div className="form-container" style={{ margin: 0 }}>
      <Form {...form}>
        <form className="custom-form-v2">
          <h1 className="text-lg font-medium">Account Details</h1>
          {/* <div className="flex flex-row justify-end w-full my-2">
            <Link>
              <Button variant={"secondary"}>Open Records</Button>
            </Link>
          </div> */}
          <div className="dialogue-form-row mt-4">
            <FormInput
              {...generalProps}
              name="name"
              label="Name"
              hideIcons
              inputProps={{ readOnly: true }}
            />
            <FormInput
              {...generalProps}
              // isRequired={true}
              name="shortName"
              label="Short Name"
              hideIcons
              inputProps={{ readOnly: true }}
            />
            <FormInput
              {...generalProps}
              // isRequired={true}
              name="customerType"
              label="Customer Type"
              hideIcons
              inputProps={{ readOnly: true }}
            />
            <FormInput
              {...generalProps}
              // isRequired={true}
              name="customerCode"
              label="Customer Code"
              hideIcons
              inputProps={{ readOnly: true }}
            />
          </div>
        </form>
      </Form>
    </div>
  );
}
